import { IHttpApi } from '@cian/http-api/shared';

import {
  fetchTripReviewsCreate,
  TTripReviewsCreateRequest,
  type TTripReviewsCreateResponse,
} from '../../repositories/dailyrent/v1/trip-reviews/create';
import { ResponseError } from '../../errors';

export interface IFetchReviewsParams {
  httpApi: IHttpApi;
  parameters: TTripReviewsCreateRequest;
}

export async function addReview({ httpApi, parameters }: IFetchReviewsParams): Promise<number | null> {
  const result: TTripReviewsCreateResponse = await fetchTripReviewsCreate({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchReviews',
      message: '',
    });
  }

  return result.response.reviewId;
}
